import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo3/biblioteca.png";
import Imagen2 from "../../../images/modulo3/enfermeria.png";
import Imagen3 from "../../../images/modulo3/laboratorio.png";
import Imagen4 from "../../../images/modulo3/salacomputo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo3 } from "../../../routes/Module3";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import InputNumber from "../../../components/InputNumber";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo3/Actividad 2.mp3";

const Actividad2 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: 4 },
    ans2: { value: "", valid: "", correctValue: 1 },
    ans3: { value: "", valid: "", correctValue: 2 },
    ans4: { value: "", valid: "", correctValue: 3 },
  });
  const infoUnidad = modulo3.content[0];
  const infoAct = modulo3.content[0].activities[1];
  const crumbs = [
    {
      title: modulo3.title,
      url: "/" + modulo3.url,
    },
    {
      title:
        modulo3.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo3.content[0].activities[2].name}`,
    linkNext: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[2].path}`,
    titlePrev: `${modulo3.content[0].activities[0].name}`,
    linkPrev: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[0].path}`,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: Number(event.target.value) },
    });
  };
  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title} - ${infoAct.name}`,
    name: modulo3.title
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo3.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 2</h2>
      <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-10 col-sm-12 mb-5">
          <ul>
            <li>
              ¿Cómo es mi escuela? Coloca en los recuadros el número que
              corresponde a cada imagen.
            </li>
            <li>
              Luego, en el espacio en blanco, escribe qué te gustaría tener en
              tu escuela y explica a un compañero, compañera o familiar por qué.
            </li>
          </ul>
        </div>
      </div>
      <div className="row my-5 align-items-center">
        <div className="col-md-6 col-lg-5 col-12">
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo3.color} circle-option me-3`}>1</div>
            <img src={Imagen1} alt="Familia" className="img-fluid img-80" />
          </div>
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo3.color} circle-option me-3`}>2</div>
            <img src={Imagen2} alt="Familia" className="img-fluid img-80" />
          </div>
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo3.color} circle-option me-3`}>3</div>
            <img src={Imagen3} alt="Familia" className="img-fluid img-80" />
          </div>
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo3.color} circle-option me-3`}>4</div>
            <img src={Imagen4} alt="Familia" className="img-fluid img-80" />
          </div>
        </div>
        <div className="col-md-6 col-lg-4 col-12 offset-lg-1 offset-0">
          <Card>
            <div className="d-flex align-items-center">
              <InputNumber
                answer={answers.ans1}
                onChangeInput={handleAnswers}
                name="ans1"
                max="4"
              />
              Sala de cómputo
            </div>
          </Card>

          <Card>
            <div className="d-flex align-items-center">
              <InputNumber
                answer={answers.ans2}
                onChangeInput={handleAnswers}
                name="ans2"
                max="4"
              />
              Biblioteca
            </div>
          </Card>
          <Card>
            <div className="d-flex align-items-center">
              <InputNumber
                answer={answers.ans3}
                onChangeInput={handleAnswers}
                name="ans3"
                max="4"
              />
              Enfermería
            </div>
          </Card>
          <Card>
            <div className="d-flex align-items-center">
              <InputNumber
                answer={answers.ans4}
                onChangeInput={handleAnswers}
                name="ans4"
                max="4"
              />
              Laboratorio
            </div>
          </Card>
          <div className="d-flex w-100 justify-content-end my-4">
            <button
              className={`btn btn-${modulo3.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>
      <div>
        <p>Me gustaría que mi escuela tenga:</p>
        <div className="row">
          <div className="col-md-6">
            <textarea className="form-control" rows={6} />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea la primera frase o palabra de la columna de la
          derecha y explique su significado. Ayude a señalar el número que
          corresponde a la imagen. Continúe con las palabras o frases
          siguientes. Luego, dialoguen acerca de qué les gustaría que tenga su
          escuela y por qué les parece importante tener ese ambiente.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
